export enum CommentColorEnum {
    red = "red",
    yellow = "yellow",
    blue = "blue",
    orange = "orange"
}
